// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__6su3D","thumb":"Slider_thumb__nwiyb","track":"Slider_track__Idaks","risks":"Slider_risks__bv2t2","risk":"Slider_risk__tYaCU"};